import { Link } from "react-router-dom";
import { LEGAL_LANGUAGE_DA, LEGAL_LANGUAGE_EN, getLegalUiText } from "./legalDocuments";

export default function LegalDocumentLayout({ title, lastUpdated, intro, children, language = LEGAL_LANGUAGE_DA, onLanguageChange, translationNotice }) {
  const uiText = getLegalUiText(language);

  return (
    <div className="legal-page">
      <div className="legal-page__card">
        <div className="legal-page__header-row">
          <div className="account-breadcrumb">
            <Link to="/legal">{uiText.breadcrumbLabel}</Link>
            <span>/</span>
            <span>{title}</span>
          </div>
          {onLanguageChange ? (
            <div className="legal-page__language-toggle" role="group" aria-label="Choose document language">
              <button
                type="button"
                className={`legal-page__language-button${language === LEGAL_LANGUAGE_DA ? " legal-page__language-button--active" : ""}`}
                onClick={() => onLanguageChange(LEGAL_LANGUAGE_DA)}
                aria-pressed={language === LEGAL_LANGUAGE_DA}
              >
                {uiText.languageLabels.da}
              </button>
              <button
                type="button"
                className={`legal-page__language-button${language === LEGAL_LANGUAGE_EN ? " legal-page__language-button--active" : ""}`}
                onClick={() => onLanguageChange(LEGAL_LANGUAGE_EN)}
                aria-pressed={language === LEGAL_LANGUAGE_EN}
              >
                {uiText.languageLabels.en}
              </button>
            </div>
          ) : null}
        </div>
        <h1 className="legal-page__title">{title}</h1>
        <p className="legal-page__intro">{intro}</p>
        <p className="legal-page__meta">{uiText.lastUpdatedLabel}: {lastUpdated}</p>
        <p className="legal-page__translation-note">{translationNotice || uiText.translationNotice}</p>
        <div className="legal-page__content">{children}</div>
        <div className="legal-page__links">
          <Link to="/terms">{uiText.relatedLinks.terms}</Link>
          <span className="legal-footer__separator">·</span>
          <Link to="/privacy">{uiText.relatedLinks.privacy}</Link>
          <span className="legal-footer__separator">·</span>
          <Link to="/cookies">{uiText.relatedLinks.cookie}</Link>
        </div>
      </div>
    </div>
  );
}